<template>
  <v-card class="rounded-card" :ref="product.picture_path">
    <v-img v-if="picture" :src="picture" aspect-ratio="1.5" ></v-img>
    <v-img v-else src="/img/img_not_found.png" aspect-ratio="1.5" contain></v-img>
    <v-card-text>
      <!--v-speed-dial
                    v-model="fab"
                    bottom
                    right
                    direction="bottom"
                    transition="slide-y-reverse-transition"
                  >
                    <template v-slot:activator>
                      <v-btn
                        v-model="fab"
                        color="rgb(0, 0, 255, 0.2)"
                        dark
                        fab
                      >
                        <v-icon>account_circle</v-icon>
                        <v-icon>close</v-icon>
                      </v-btn>
                    </template>
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="indigo"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                    <v-btn
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial-->
      <v-layout row wrap justify-center align-center v-if="product.serial_number">
        <v-flex xs12 py-1 class="text-xs-center">
          <h2><span class="orange--text" v-if="product.pair">(P) </span>{{product.serial_number}}</h2>
        </v-flex>
        <v-flex xs12 py-1 class="text-xs-center">
          <h3>
            <div 
              right 
              class="font-weight-black" 
              :style="{color: currentList.color}"
              >
              <div v-if="product.pesos_price">
                {{product.pesos_price * currentListPercentage| currency }}
              </div>
              <div
                v-else
                class="show-price" 
                @click="showPrice()"
              >
                Mostrar precio
              </div>
            </div>
          </h3>
          <v-icon v-if="hasRole('ADMINISTRATOR') || hasRole('METAL_LOAD_ADV') || hasRole('METAL_LOAD_BAS') || hasRole('SUPERVISOR')" @click="loadHistoricPrices(product)">history</v-icon>
        </v-flex>
        <v-flex xs12 py-1 class="text-xs-center">
          <h3><div >{{product.maker_name}}</div></h3>
        </v-flex>
        <v-flex xs12 py-1 class="text-xs-center">
          <div class="subheading">{{product.description}}</div>
        </v-flex>
        <v-flex v-if="product.reference_1" xs12 py-1 class="text-xs-center">
          <div class="subheading">{{product.reference_1}}</div>
        </v-flex>
        <v-flex v-if="product.reference_2" xs12 py-1 class="text-xs-center">
          <div class="subheading">{{product.reference_2}}</div>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center v-if="(hasRole('ADMINISTRATOR') || hasRole('SUPERVISOR')) || hasRole('METAL_LOAD_ADV') || hasRole('METAL_LOAD_BAS') && product.serial_number">        
        <v-flex xs12 py-1 class="text-xs-center">
          <div class="">{{product.weigth_grams | currency('', 0)}} gr</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="(hasRole('ADMINISTRATOR') || hasRole('SUPERVISOR')) && product.serial_number">       
        <v-flex xs12 py-1 class="text-xs-center">
          <div class="">{{product.dollar_price | currency}} Dll</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="(hasRole('ADMINISTRATOR') || hasRole('SUPERVISOR')) || hasRole('METAL_LOAD_ADV') || hasRole('METAL_LOAD_BAS') && product.serial_number">       
        <v-flex xs12 py-1 class="text-xs-center" v-if="product.picture_path">
          <router-link :to="{ path: '/images', query: { img: product.picture_path }}"><v-icon>photo_camera</v-icon></router-link>
        </v-flex>
        <v-flex xs12 py-1 class="text-xs-center">
          <div class="">{{product.country_name}}</div>
        </v-flex>

      </v-layout>
      <v-flex xs12 py-1
        class="text-xs-center"
        v-if="hasRole('ADMINISTRATOR') || hasRole('USER') || hasRole('SUPERVISOR') || hasRole('METAL_LOAD_ADV') || hasRole('METAL_LOAD_BAS') || currentType ==='USER' "
        >
          <a color="success" @click="$emit('findSimilar', product.picture_path)">Ver similares</a>
      </v-flex>
      <!--v-flex  xs1 @click="selectProduct(product)">
        <v-layout align-center justify-center row fill-height>
          <v-icon color="green">keyboard_arrow_right</v-icon>
        </v-layout>
      </v-flex-->
      
    </v-card-text>
  </v-card>
</template>
<script>

import productCardUtilitesMixin from '../../mixins/productCardUtilitesMixin';
import { cachiosInstance } from '../../axios';

export default {
  name: 'product-card',
  props: ['product'],
  mixins: [productCardUtilitesMixin],
  data() {
    return {
      picture: '',
    };
  },
  watch: {
    product: {
      handler(newValue) {
        if (newValue) {
          this.retrieveImage();
        }
      },
    },
  },
  methods: {
    async retrieveImage() {
      cachiosInstance.get(`/img/${this.product.picture_path}`)
        .then( (result) => {
          this.picture = result.data;
        })
        .catch( (error) => {
          this.$emit('no-picture', this.product);
        });
    },
    loadHistoricPrices(product) {
      this.$emit('loadHistoricPrices', product);
    },
    showPrice() {
      const body = {
        "no_zero": true,
        "product_id": this.product.product_id
      }
      cachiosInstance.post(`/catalogs/product/search/single`, body )
        .then( (result) => {
          if (result.status === 204){
            this.$emit('limit');
          }else{
            if(result.data.pesos_price) {
              this.$emit('get_price', result.data)
            }
          }
         
        })
        .catch( (error) => {
        });
    }
  },

  mounted() {
    if (this.product.picture_path) {
      this.retrieveImage();
    }
  },
};
</script>

<style scoped>
  .rounded-card{
    border-radius:6px;
  }

  .show-price{
    cursor: pointer;
  }
</style>